import MediaOverlayIconButton from '@components/MediaOverlayIconButton/MediaOverlayIconButton';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { MouseEvent } from 'react';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';
import { NavigationDirection } from './TeceoSlickerLib';

const NAV_INSET = 1;

const useStyles = makeStyles<{ selectCursor?: string }>()((theme, { selectCursor }) => ({
  rootContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: theme.spacing(NAV_INSET),
    cursor: selectCursor,
  },
}));

type TeceoSlickerNavigatorsProps = {
  navigate: (direction: NavigationDirection) => void;
  canNavigate: boolean;
  selectCursor?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

const TeceoSlickerNavigators = ({
  navigate,
  canNavigate,
  onClick,
  selectCursor,
}: TeceoSlickerNavigatorsProps) => {
  const { translate } = useTranslation();
  const { classes } = useStyles({ selectCursor });

  const handleNavigate = (event: MouseEvent<HTMLButtonElement>, direction: NavigationDirection) => {
    event.stopPropagation();
    event.preventDefault();
    navigate(direction);
  };

  return (
    <div className={classes.rootContainer} onClick={onClick}>
      {canNavigate && (
        <>
          <MediaOverlayIconButton
            icon={ArrowLeft}
            tabIndex={-1}
            ariaLabel={translate(LangEnum.GLOBAL_PREVIOUS)}
            onClick={(event) => handleNavigate(event, -1)}
          />

          <MediaOverlayIconButton
            icon={ArrowRight}
            tabIndex={-1}
            ariaLabel={translate(LangEnum.GLOBAL_NEXT)}
            onClick={(event) => handleNavigate(event, 1)}
          />
        </>
      )}
    </div>
  );
};

export default TeceoSlickerNavigators;
